import { LocalStorageService } from '@/services/localStorageService';
import { getCookieAccess } from '@/helpers/getCookieAccess';
import { LOCAL_STORAGE_KEYS } from '@/constants';
import { isGpcSignalPresent } from './isGpcSignalPresent';

/**
 * Is GPC active for this user right now?
 *
 * True only when the GPC signal is present AND the user's geo is in scope
 * (USA or EU/UK). Geo is read live from localStorage on each call (cheap reads,
 * same pattern as `getCookieAccess`/`getCCPAAccess`) — NOT memoized — because
 * the geo lookup resolves asynchronously after first paint. Memoizing the whole
 * result would freeze a stale `false` computed before geo resolved.
 *
 * - EU/UK  → `getCookieAccess()` (country_code ∈ COOKIES_ACCESS_REGION)
 * - USA    → country_code === 'US' (any state)
 * - geo unresolved / rest of world → false (existing regional rules apply)
 */
export const isGpcApplicable = (): boolean => {
	if (!isGpcSignalPresent()) {
		return false;
	}

	const countryCode = LocalStorageService.get<string>(
		LOCAL_STORAGE_KEYS.COUNTRY_CODE,
		'',
	);
	const isUsa = countryCode === 'US';

	return isUsa || getCookieAccess();
};
